import { ContextWrapper } from '@common/contexts';
import { ClientRecentResultsStore } from '@common/stores';

export const RecentClientSearchStoreContextWrapper =
  new ContextWrapper<ClientRecentResultsStore>();
